import React from 'react';
import { SRLWrapper } from "simple-react-lightbox";
import { Container } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import portfolio_1 from "../assets/img/projects/project-1.jpg";
import portfolio_2 from "../assets/img/projects/project-2.jpg";
import portfolio_3 from "../assets/img/projects/project-3.jpg";
import portfolio_4 from "../assets/img/projects/project-4.jpg";
import portfolio_5 from "../assets/img/projects/project-5.jpg";
import portfolio_6 from "../assets/img/projects/project-6.jpg";
import portfolio_7 from "../assets/img/projects/project-7.jpg";
import portfolio_8 from "../assets/img/projects/project-8.jpg";
import portfolio_9 from "../assets/img/projects/project-9.jpg";
import portfolio_10 from "../assets/img/projects/project-10.jpg";
import portfolio_11 from "../assets/img/projects/project-11.jpg";
import portfolio_12 from "../assets/img/projects/project-12.jpg";
const images = [
    {image : portfolio_1, title : 'project 1' },
    {image : portfolio_2, title : 'project 2' },
    {image : portfolio_3, title : 'project 3' },
    {image : portfolio_4, title : 'project 4' },
    {image : portfolio_5, title : 'project 5' },
    {image : portfolio_6, title : 'project 6' },
    {image : portfolio_7, title : 'project 7' },
    {image : portfolio_8, title : 'project 8' },
    {image : portfolio_9, title : 'project 9' },
    {image : portfolio_10, title : 'project 10' },
    {image : portfolio_11, title : 'project 11' },
    {image : portfolio_12, title : 'project 12' }
];
const options = {
    settings: {
        autoplaySpeed: 0,
        slideAnimationType: 'slide',
        slideSpringValues: [2000, 200],
        disableWheelControls: true,
        hideControlsAfter: false,
        disablePanzoom: true,
    },
    buttons: {
        showAutoplayButton: false,
        showDownloadButton: false,
        showFullscreenButton: false
    },
    thumbnails: {
        showThumbnails: false
    },
    caption: {
        captionColor: '#ffffff',
        captionFontSize: '20px',
        captionTextTransform: 'uppercase',
        showCaption: true
    }
}
class Portfolio extends React.Component {
    componentDidMount(){
        document.title = "My Portfolio - Tunis React Personal Portfolio";
        window.scrollTo(0,0);
        const nodes = [].slice.call(document.querySelectorAll('.portfolio-item'), 0);
        const directions = { 0: 'top', 1: 'right', 2: 'bottom', 3: 'left' };
        const classNames = ['in', 'out'].map(p => Object.values(directions).map(d => `${p}-${d}`)).reduce((a, b) => a.concat(b));
        const getDirectionKey = (ev, node) => {
            const { width, height, top, left } = node.getBoundingClientRect();
            const l = ev.pageX - (left + window.pageXOffset);
            const t = ev.pageY - (top + window.pageYOffset);
            const x = l - width / 2 * (width > height ? height / width : 1);
            const y = t - height / 2 * (height > width ? width / height : 1);
            return Math.round(Math.atan2(y, x) / 1.57079633 + 5) % 4;
        };
        class Item {
            constructor(element) {
                this.element = element;
                this.element.addEventListener('mouseover', ev => this.update(ev, 'in'));
                this.element.addEventListener('mouseout', ev => this.update(ev, 'out'));
            }

            update(ev, prefix) {
                this.element.classList.remove(...classNames);
                this.element.classList.add(`${prefix}-${directions[getDirectionKey(ev, this.element)]}`);
            }}
        nodes.forEach(node => new Item(node));
    }
    render() {
        return (
            <Scrollbars>
                <div className="portfolio">
                    <section className="title-section text-left text-sm-center">
                        <h1>my <span>portfolio</span></h1>
                        <span className="title-bg">works</span>
                    </section>
                    <section className="main-content main-content-portfolio text-center">
                        <Container>
                                <SRLWrapper options={options}>
                                    {
                                        Object.keys(images).map((item, i) => (
                                            <div className="portfolio-item" key={i}>
                                                <a href={`${images[item].image}`} data-attribute="SRL">
                                                    <img className="img-fluid" src={`${images[item].image}`} alt={`${images[item].title}`} />
                                                </a>
                                                <div className="info d-none d-lg-flex">
                                                    <h3>{`${images[item].title}`}</h3>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </SRLWrapper>
                        </Container>
                    </section>
                </div>
            </Scrollbars>
        );
    }
}

export default Portfolio